import React, { useState } from 'react';
import { Card, Button, Form, InputNumber, Col, Row, Divider, message } from 'antd';
import AvatarStatus from 'componentsv2/AvatarStatus/AvatarStatus';
import { useParams } from 'react-router-dom';
import { updateVolleyballMatchDetails } from 'api/events';

const SetsList = ({ match, set, index, onLoadRounds, onLoadSets }) => {
  const { id: matchId, home, visit } = match || {};
  let { matchDayId } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmitSet = async ({ club_score, opponent_score }) => {
    setIsLoading(true);
    message.loading('Actualizando marcador', 1);
    try {
      await updateVolleyballMatchDetails(matchDayId, matchId, set.id, club_score, opponent_score);
      await onLoadRounds();
      message.success('!Marcador actualizado con éxito!');
      await onLoadSets();
      setIsLoading(false);
    } catch (error) {
      message.error('!Ha ocurrido un error!');
    }
  };
  return (
    <>
      <Card
        style={{ marginTop: 16 }}
        headStyle={{
          backgroundImage:
            'background-image: linear-gradient(to right, #ffffff, #f7f7f7, #eeeeee, #e6e6e6, #dedede)',
        }}
        type="inner"
        title={<div style={{ display: 'flex', justifyContent: 'center' }}>Set {index}</div>}
      >
        <Col flex xs={24} sm={24} md={24} lg={24} xl={24}>
          <Row justify="center" align="middle">
            <AvatarStatus size={60} src={home?.avatar_url} name={home?.name} />
            <Form
              onFinish={values => onSubmitSet(values)}
              id={`setForm${set?.id}`}
              layout="inline"
              style={{ alignItems: 'center' }}
              size="large"
            >
              <Form.Item
                initialValue={set?.club_score ? set?.club_score : 0}
                className="set-list-field"
                style={{
                  marginLeft: '16px',
                  marginRight: '26px',
                  marginBottom: '0',
                  width: '75px',
                }}
                name="club_score"
                rules={[
                  {
                    required: true,
                    message: '',
                  },
                ]}
              >
                <InputNumber min={0} />
              </Form.Item>
              -
              <Form.Item
                initialValue={set?.opponent_score ? set?.opponent_score : 0}
                className="set-list-field"
                style={{
                  marginLeft: '16px',
                  marginRight: '26px',
                  marginBottom: '0',
                  width: '75px',
                }}
                name="opponent_score"
                rules={[
                  {
                    required: true,
                    message: '',
                  },
                ]}
              >
                <InputNumber min={0} />
              </Form.Item>
            </Form>

            <AvatarStatus size={60} src={visit?.avatar_url} inverted={true} name={visit?.name} />
          </Row>
        </Col>
        <Divider></Divider>
        <Col flex xs={24} sm={24} md={24} lg={24} xl={24}>
          <Row justify="center">
            <Button loading={isLoading} form={`setForm${set?.id}`} htmlType="submit" type="primary">
              GUARDAR MARCADOR
            </Button>
          </Row>
        </Col>
      </Card>
    </>
  );
};

export default SetsList;
